var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlignCenter2Icon = function SvgAlignCenter2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.6 15.2a.4.4 0 0 1-.4-.4v-3.6H1.6a.8.8 0 0 1-.8-.8V5.6a.8.8 0 0 1 .8-.8h5.6V1.2c0-.22.179-.4.4-.4h.8c.22 0 .4.18.4.4v3.6h5.6a.8.8 0 0 1 .8.8v4.8a.8.8 0 0 1-.8.8H8.8v3.6a.4.4 0 0 1-.4.4h-.8Zm6-5.6V6.4H2.4v3.2h11.2Z",
    clipRule: "evenodd"
  })));
};
export default SvgAlignCenter2Icon;